
import { async_command_dispatcher } from "@/api/client"

export class SaveRepresentationModelCommand {
  constructor(
    private readonly dispatcher,
    private readonly frontend,
  ) { }

  async run(commandData, user_id): Promise<any> {
    try {
      const args = {
        pdf_representation_url: commandData.pdf_representation_url || commandData.url,
        company_id: commandData.company_id,
        user_id: user_id || commandData.user_id
      };

      const response = await async_command_dispatcher.dispatch_with_result('save.representation.model', args);

      return response;
    } catch (error) {
      console.error('Error al guardar el modelo de representación:', error);
      throw error;
    }
  }
}
